import banner from "../assets/banner/char.png";

const Home = () => {
  const email = "ryancordial.job@gmail.com";
  const subject = "I have a job opportunity for you";
  const message = "I am interested in discussing job opportunities.";

  const gmailComposeLink = `https://mail.google.com/mail/?view=cm&fs=1&to=${email}&su=${encodeURIComponent(
    subject
  )}&body=${encodeURIComponent(message)}`;

  return (
    <section className="home_banner_area" id="home">
      <div className="banner_inner">
        <div className="container">
          <div className="row">
            <div className="col-lg-7">
              <div className="banner_content">
                <h3 className="text-uppercase">Hello</h3>
                <h1 className="text-uppercase">
                  I am <br /> <span>ryan cordial</span>
                </h1>

                <h5 className="text-uppercase">Software Developer</h5>
                <p>
                  Dedicated Software Developer in the Philippines Ready to
                  Contribute Expertise.
                </p>
                <div className="footer_top flex-column">
                  <div
                    className="footer_social"
                    style={{ margin: "2rem 0rem" }}
                  >
                    <a
                      href="https://facebook.com/rsc0531  "
                      rel="noreferrer"
                      target="_blank"
                    >
                      <i className="fa fa-facebook"></i>
                    </a>
                    <a
                      href="https://github.com/ryncrdl"
                      rel="noreferrer"
                      target="_blank"
                    >
                      <i className="fa fa-github"></i>
                    </a>
                    <a
                      href="https://www.linkedin.com/in/ryan-cordial"
                      rel="noreferrer"
                      target="_blank"
                    >
                      <i className="fa fa-linkedin"></i>
                    </a>
                    <a
                      href="https://instagram.com/_ryxzer"
                      rel="noreferrer"
                      target="_blank"
                    >
                      <i className="fa fa-instagram"></i>
                    </a>
                  </div>
                </div>
                <div className="d-flex align-items-center">
                  <a
                    className="primary_btn"
                    href={gmailComposeLink}
                    rel="noreferrer"
                    target="_blank"
                  >
                    <span>Hire Me</span>
                  </a>
                  <a
                    className="primary_btn tr-bg"
                    href="https://drive.google.com/file/d/1S14HDdYQ3Pm3rcSmhHmvr2H8LMUwEt4J/view"
                    rel="noreferrer"
                    target="_blank"
                  >
                    <span>Get CV</span>
                  </a>
                </div>
              </div>
            </div>
            <div className="col-lg-5">
              <div className="home_right_img">
                <img className="" src={banner} alt="Banner" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Home;
